import { InfoIcon, LinkIcon } from '@air/design-icons';
import { Tooltip } from '@air/primitive-tooltip';

export const NoPermissionToCreateShareLink = () => (
  <div className="flex items-center justify-between">
    <div className="flex items-center">
      <LinkIcon className="ads:text-icon-subtle text-gray-9" size="sm" />
      {/* biome-ignore lint/plugin: PLA-1724 — pre-existing debt, not introduced by the icon migration */}
      <p className="pl-2 ads:text-metadata text-16 text-gray-9" data-testid={'NO_SHARE_LINK'}>
        No shareable link
      </p>
    </div>
    {/* biome-ignore lint/plugin: PLA-1724 — pre-existing debt, not introduced by the icon migration */}
    <div className="mr-3" data-testid={'LINK_NOT_AVAILABLE'}>
      <Tooltip label="You do not have permissions to create this link. Contact your workspace admin for help.">
        <InfoIcon className="ads:text-icon-subtle text-gray-9" size="md" />
      </Tooltip>
    </div>
  </div>
);
